import { createTheme } from '@mui/material/styles';
import tokens from './tokens';
import typography from './typography';
import getComponents from './components';

export function buildTheme(mode) {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      ...(isDark
        ? {
            background: { default: '#121212', paper: '#1e1e1e' },
            text: { primary: '#ffffff' },
          }
        : {
            background: { default: '#f9f9f9', paper: '#ffffff' },
            text: { primary: '#000000' },
          }),
      meal: tokens.colors.meal,
      macro: tokens.colors.macro,
      streak: tokens.colors.streak,
      goal: tokens.colors.goal,
      achievement: {
        locked: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.26)',
      },
      brand: tokens.colors.brand,
      celebration: tokens.colors.celebration,
    },
    shape: {
      borderRadius: tokens.radius.md,
    },
    typography,
    components: getComponents(tokens),
  });
}

export { radius, colors } from './tokens';
export * from './safeArea';
